<template>
	<div class="wx-launch-container">
		<!-- 微信环境 -->
		<wx-open-launch-weapp v-if="isWechat" :key="componentKey" :username="username" :path="formattedPath"
			id="launch-btn" @error="onError" @launch="onLaunch">
			<script type="text/wxtag-template">
				<style>
					.wx-btn {{ wxbtnStyle }}
				</style>
				<div class="wx-btn">
					{{ btnText }}
				</div>
			</script>
		</wx-open-launch-weapp>
		<!-- 非微信环境 -->
		<div v-else :style="notwxbtnStyle" @click="btnTap">
			{{ btnText }}
		</div>
		<van-popup v-model="showQrcode" :overlay-style="{'position':'fixed'}" class="popup-wrap">
			<img :src="require(`../assets/images/new/${imgName}.png`)" alt="" class="qrcode">
		</van-popup>
	</div>
</template>
<script>
	export default {
		name: 'wxLaunchWeapp',
		props: {
			username: {
				type: String,
				required: true,
			},
			closeQrcode: {
				type: Boolean,    
			},
			path: {
				type: String,
				default: '/pages/index/index'
			},
			imgName: {
				type: String,
			},
			params: {
				type: [Object, Function],
				default: () => ({})
			},
			wxbtnStyle: {
				type: String,
				default: '',
			},
			notwxbtnStyle: {
				type: [Object, Function],
				default: () => ({
					fontSize: "12px",
					lineHeight: "32px",
					textAlign: "center",
					cursor: "pointer",
					width: "247px",
					height: "32px",
					border: "1px solid #fff",
					borderRadius: "16px",
					color: "#fff",
					margin: "0 auto",
				})
			},
			btnText: {
				type: String,
				default: ''
			},
		},

		data() {
			return {
				isWechat: false,
				componentKey: 0,
				showQrcode: false,
			}
		},

		computed: {
			formattedPath() {
				const path = this.getDynamicValue('path')
				const params = this.getDynamicValue('params')
				if (!params || Object.keys(params).length === 0) {
					return path
				}
				const query = new URLSearchParams(params).toString()
				return `${path}?${query}`
			}
		},

		methods: {
			close() {
				this.showQrcode = false;
			},
			getDynamicValue(prop) {
				const value = this[prop]
				return typeof value === 'function' ? value() : value
			},
			checkWechat() {
				this.isWechat = /micromessenger/i.test(navigator.userAgent)
			},
			onError(error) {
				this.$emit('error', error)
			},

			onLaunch() {
				this.$emit('launch')
			},

			btnTap() {
				this.showQrcode = true;
			},
			updateComponent() {
				this.componentKey += 1
			},
		},
		watch: {
			path: {
				handler() {
					this.updateComponent()
				},
				deep: true
			},
			params: {
				handler() {
					this.updateComponent()
				},
				deep: true
			},
			closeQrcode: {
				handler(e) {
					if (e) {
						this.showQrcode = false;
					}
				},
				deep: true
			}
		},

		mounted() {
			this.checkWechat()
		}
	}
</script>

<style scoped>
	
	.qrcode {
		width: 160px;
		height: 160px;
	}
	.popup-wrap {
		border-radius: 3px;

		.qrcode {
			width: 160px;
			height: 160px;
		}
	}
</style>